import {
  ADD_LAYOUT,
  ADD_ROW,
  ADD_WIDGET,
  CLEAR_DASHBOARD,
  CREATE_REPORT_GROUP,
  DELETE_LAYOUT,
  DELETE_REPORT_GROUP,
  FETCH_DASHBOARD,
  FETCH_REPORTS,
  MOVE_COLUMN,
  MOVE_WIDGET,
  REMOVE_ROW,
  REMOVE_WIDGET,
  RENAME_LAYOUT,
  SAVE_LAYOUT,
  SORT_COLUMNS,
  SORT_WIDGETS,
  SWITCH_ACTIVE_LAYOUT,
  SWITCH_EDIT_LAYOUT_MODE,
  UPDATE_COLUMN_PROPERTY,
  UPDATE_REPORT_GROUP,
  UPDATE_WIDGET,
} from './constants';

export function updateColumnProperty(args) {
  return {
    type: UPDATE_COLUMN_PROPERTY,
    payload: args,
  };
}

export function addRow(args) {
  return {
    type: ADD_ROW,
    payload: args,
  };
}

export function removeRow(args) {
  return {
    type: REMOVE_ROW,
    payload: args,
  };
}

export function removeWidget(args) {
  return {
    type: REMOVE_WIDGET,
    payload: args,
  };
}

export function addWidget(args) {
  return {
    type: ADD_WIDGET,
    payload: args,
  };
}

export function updateWidget(args) {
  return {
    type: UPDATE_WIDGET,
    payload: args,
  };
}

export function sortWidgets(args) {
  return {
    type: SORT_WIDGETS,
    payload: args,
  };
}

export function moveWidget(args) {
  return {
    type: MOVE_WIDGET,
    payload: args,
  };
}

export function moveColumn(args) {
  return {
    type: MOVE_COLUMN,
    payload: args,
  };
}

export function sortColumns(args) {
  return {
    type: SORT_COLUMNS,
    payload: args,
  };
}

export function fetchDashboard() {
  return {
    type: FETCH_DASHBOARD,
  };
}

export function switchActiveLayout(args) {
  return {
    type: SWITCH_ACTIVE_LAYOUT,
    payload: args,
  };
}

export function switchEditLayoutMode(args) {
  return {
    type: SWITCH_EDIT_LAYOUT_MODE,
    payload: args,
  };
}

export function addLayout(args) {
  return {
    type: ADD_LAYOUT,
    payload: args,
  };
}

export function renameLayout(args) {
  return {
    type: RENAME_LAYOUT,
    payload: args,
  };
}

export function deleteLayout(args) {
  return {
    type: DELETE_LAYOUT,
    payload: args,
  };
}

export function updateReportGroup(args) {
  return {
    type: UPDATE_REPORT_GROUP,
    payload: args,
  };
}

export function createReportGroup(args) {
  return {
    type: CREATE_REPORT_GROUP,
    payload: args,
  };
}

export function deleteReportGroup(args) {
  return {
    type: DELETE_REPORT_GROUP,
    payload: args,
  };
}

export function saveLayout(args) {
  return {
    type: SAVE_LAYOUT,
    payload: args,
  };
}

export function clearDashboard() {
  return {
    type: CLEAR_DASHBOARD,
  };
}

export function fetchReports() {
  return {
    type: FETCH_REPORTS,
  };
}
